/**
 * Custom Hook: useFormData
 * Manages form input state with initialization and change handlers
 */

import { useState } from "react";

const getDefaultFormState = () => {
  const currentDate = new Date().toISOString().split("T")[0];
  return {
    fullname: "",
    phone: "",
    chasisNo: "",
    engineNo: "",
    year: "",
    agVehicleMakeModelId: "",
    agVehicleType: "",
    agPolicyType: "",
    make: "",
    model: "",
    color: "",
    nin: "",
    email: "",
    effectiveDate: currentDate,
    state: "lagos",
    dob: "2/2/24",
    gender: "Male",
    occupation: "Work",
    address: "address",
    plate_no: "",
  };
};

export const useFormData = (initialOverrides = {}) => {
  const [input, setInput] = useState({
    ...getDefaultFormState(),
    ...initialOverrides,
  });

  /**
   * Handle simple input changes
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  /**
   * Update specific field in form
   */
  const updateField = (fieldName, value) => {
    setInput((prev) => ({ ...prev, [fieldName]: value }));
  };

  /**
   * Batch update multiple fields
   */
  const updateMultipleFields = (updates) => {
    setInput((prev) => ({ ...prev, ...updates }));
  };

  /**
   * Reset form to default state
   */
  const resetForm = () => {
    setInput(getDefaultFormState());
  };

  /**
   * Get specific field value
   */
  const getFieldValue = (fieldName) => {
    return input[fieldName];
  };

  return {
    input,
    setInput,
    handleInputChange,
    updateField,
    updateMultipleFields,
    resetForm,
    getFieldValue,
  };
};
